import { render, staticRenderFns } from "./EnvironmentSwitcher.vue?vue&type=template&id=33eba831"
import script from "./EnvironmentSwitcher.vue?vue&type=script&lang=js"
export * from "./EnvironmentSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports